<template>
  <v-chip
    v-bind="$attrs"
    v-on="$listeners"
    :class="$attrs.filter && !inputValue ? chipClass + ' filterChip' : chipClass"
    :color="chipStyle.colour"
    :close="$attrs.filter && filterIcon ? true : false"
    :text-color="chipStyle.textColour"
    :close-icon="$attrs.filter && filterIcon && !inputValue ? filterIcon : closeIcon"
    @click:close="$emit($attrs.filter && filterIcon && inputValue ? 'handleFilter' : 'close')"
  >
    <slot name="default">
      <v-avatar
        v-if="avatar || avatarIcon"
        left
      >
        <v-icon
          circle
          v-if="avatarIcon"
        >
          {{ avatarIcon }}
        </v-icon>
        <span v-if="avatar">{{ avatar }}</span>
      </v-avatar>
      <span>{{ inputValue ? inputValue : text }}</span>
    </slot>
  </v-chip>
</template>

<script>
import {ADS_Colors} from '../ads-colors';

export default {
  name: 'Chip',
  props: {
    filterIcon: {
      type: String,
      default: 'arrow_drop_down'   // override the default value '$complete' in v-chip
    },
    textColor: {
      type: String,
      default: ADS_Colors.White   // override the default value 'undefined' in v-chip
    },
    closeIcon: {
      type: String,
      default: 'cancel'   // override the default value '$delete' in v-chip
    },
    chipClass: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'Chip Text'
    },
    avatar: {
      type: String,
      default: ''
    },
    avatarIcon: {
      type: String,
      default: null
    },
    inputValue: {
      type: String,
      default: null
    }
  },
  computed: {
    chipStyle() {
      if (this.$attrs.outlined) {
        return {
          colour: this.$attrs.color ? this.$attrs.color : ADS_Colors.Navy,
          textColour: this.$attrs.color ? this.$attrs.color : ADS_Colors.Navy
        };
      } else {
        return {
          colour: this.$attrs.color ? this.$attrs.color : ADS_Colors.Navy,
          textColour: this.textColor
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.theme--dark .v-chip {
  background-color: $ads-dark;
  border: 0.5px solid $ads-light-20;
  color: $ads-light-20;
}

.theme--dark .v-chip.v-chip--removable:not(.filterChip) {
  background-color: $ads-dark;
  border: 0.5px solid $ads-navy-dark;
  color: $ads-navy-dark;

  ::v-deep .v-icon {
    color: $ads-navy-dark;
  }
}

.theme--light .v-chip {
  background-color: $ads-white;
  border: 0.5px solid $ads-dark-60;
  color: $ads-navy;
}

.theme--light .v-chip.v-chip--removable:not(.filterChip) {
  background-color: $ads-light-blue;
  border: 0.5px solid $ads-navy;
  color: $ads-navy;
}
</style>
